/* eslint-disable no-shadow */

import Vue from 'vue';

import Common from '@/store/common';

const state = {
  activeUser: {},
  sessionId: '',
  willAuthenticate: false,
};

const getters = {
  isAuthenticated: state => !!state.activeUser.id,
  isAdminUser: state => state.activeUser.admin,
  fullName: state => `${state.activeUser.first_name} ${state.activeUser.last_name}`,
};

const mutations = {
  setSessionId(state, sessionId) {
    state.sessionId = sessionId;
  },

  removeSessionId(state) {
    state.sessionId = '';
  },

  setActiveUser(state, user) {
    state.activeUser = user;
  },

  removeActiveUser(state) {
    state.activeUser = {};
  },

  setWillAuthenticate(state, willAuthenticate) {
    state.willAuthenticate = willAuthenticate;
  },
};

const actions = {
  authenticate({ commit, dispatch }, authToken) {
    return Vue.axios.post('auth', { auth_token: authToken })
      .then((response) => {
        dispatch('loginUser', { sessionId: response.data.session_id, displayMessage: true });
      }).catch(error => Common.handleError(dispatch, error.response));
  },

  loginUser({ commit, dispatch }, { sessionId, displayMessage }) {
    localStorage.setItem('surveySessionId', sessionId);
    commit('setSessionId', sessionId);
    return Vue.axios.get('me')
      .then((response) => {
        commit('setActiveUser', response.data.me);
        commit('setWillAuthenticate', false);
        if (displayMessage) {
          dispatch('setMessage', { text: 'Successfully logged in' });
        }
      }).catch(error => Common.handleError(dispatch, error.response));
  },

  logout({ commit, dispatch }) {
    return Vue.axios.delete('auth')
      .then(() => {
        localStorage.removeItem('surveySessionId');
        commit('removeSessionId');
        commit('removeActiveUser');
      }).catch(error => Common.handleError(dispatch, error));
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
